import { cssVars, cx } from '@/lib/cx';
import s from './Skeleton.module.css';

/** Placeholder shapes while data loads. Widths/heights are data-driven CSS variables. */
export function Skeleton({ width, height, radius, className }: { width?: string; height?: string; radius?: 'sm' | 'md' | 'full'; className?: string }) {
  return <span className={cx(s.skeleton, radius && s[radius], className)} style={cssVars({ '--sk-w': width, '--sk-h': height })} aria-hidden />;
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <span className={cx(s.lines, className)} aria-hidden>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} width={i === lines - 1 ? '60%' : '100%'} height="0.8em" />
      ))}
    </span>
  );
}
